import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <p>
        &copy; {currentYear} Nest Iris Association | Powered by{" "}
        <a href="https://residy.app">Residy</a>
      </p>
    </footer>
  );
};

export default Footer;
